export const FORM_LABEL = '*Campos obligatorios';
export const FORM_CHECK_TITLE = '¿Está todo bien?';
export const FORM_CHECK_MESSAGE =
  'Verifica que los datos sean correctos antes de continuar.';
export const LABEL_REGION = 'Región (*)';
export const LABEL_COMMUNE = 'Comuna (*)';
export const LABEL_STREET_NAME = 'Calle (*)';
export const LABEL_FIND_ADDRESS = 'Buscar dirección (*)';
export const LABEL_STREET_NUMBER = 'Número (*)';
export const LABEL_NO_NUMBER = 'Sin número';
export const LABEL_ADDITIONAL_STREET_INFO = 'Departamento, oficina o casa';
export const LABEL_ALIAS = 'Nombre para esta dirección (*)';
export const LABEL_ADDITIONAL_INFO = 'Información adicional';
export const LABEL_SAVE_ADDRESS = 'Quiero guardar esta dirección';
export const LABEL_CONTACT_INFO = 'Información de contacto';
export const LABEL_FIRST_NAME = 'Nombre (*)';
export const LABEL_LAST_NAME = 'Apellido (*)';
export const LABEL_PHONE_PREFIX = 'Código (*)';
export const LABEL_PHONE = 'Teléfono (*)';
